// extracted by mini-css-extract-plugin
export default {"container":"Favoritos_container__JS8M1"};